import { message as $message } from 'antd'
import { querySupplierFirstPageNum, queryDeliverWarningNum } from '@/services/supplier'

const SupplierFirstPageNumModel = {
    namespace: 'dashboardNum',
    state: {
        supplierFirstPageNum: {}, // 代发订单（待发货）数量
        deliverWarningNum: {},
    },
    effects: {
        *getSupplierFirstPageNum({ payload }, { call, put }) {
            try {
                const res = yield call(querySupplierFirstPageNum, payload)
                if (res.success) {
                    if (res.data) {
                        const result = { supplierFirstPageNum: res.data }
                        yield put({
                            type: 'update',
                            payload: result,
                        })
                        return res.data
                    }
                } else {
                    $message.error(res.message)
                }
            } catch (e) {
                console.error('catchError', e)
            }
        },
        *getDeliverWarningNum({ payload }, { call, put }) {
            try {
                const res = yield call(queryDeliverWarningNum, payload)
                if (res.success) {
                    if (res.data) {
                        const result = { deliverWarningNum: res.data }
                        yield put({
                            type: 'update',
                            payload: result,
                        })
                        return res.data
                    }
                } else {
                    $message.error(res.message)
                }
            } catch (e) {
                console.error('catchError', e)
            }
        },
    },
    reducers: {
        update(state, { payload }) {
            return {
                ...state,
                ...payload,
            }
        },
    },
}

export default SupplierFirstPageNumModel
